var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url,"target":"_blank","rel":"noopener noreferrer"},on:{"click":_vm.linkClick}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }